module.exports = __webpack_public_path__ + "img/s1_t1_11.b429e377.jpeg";